import React,{ useState, useEffect, useRef} from "react";
import { Row,  Card, Col, Container, CardBody, CardHeader, Button, Modal, ModalBody, ModalHeader, Alert} from "shards-react";
import { ProtectedRoute } from "../../../ProtectedRoute";
import AdminService from "../../../flux/services/AdminService";
import DataTable from "react-data-table-component";
import {useReactToPrint} from "react-to-print"
import PageTitle from "../../../components/common/PageTitle";
import tableCustomerStyles from "../../../utils/tableCustomStyles";
import InvoiceDetails from "./InvoiceDetails";
 
export default function Invoice (props)
{

  
  const profile = props.profile;
  let [refresh, setRefresh] = useState({ refresh: props.refresh})
  const [state, setState]= useState({
    memberId: props.memberId,
    view: props.view,
    profile: props.profile
  });
  const [modal, setModal] = useState({
    modal: false
  });

  const [invoiceDetails, setInvoiceDetails] = useState({
    invoiceId: null,
    memberId: null, 
    amountDue: null
  });

  const [data, setData] = useState(null);
  const InvoiceRef = useRef();

  useEffect(() => {
    let ismounted = true;
//    async function getClearingNames(memId, profile){

      try {

        let data = null;
        // set loading to true before calling API
          /*data = */ AdminService.getInvoices().then(data => {if (ismounted) setData(data)});

        /*setData(data);*/

      } catch (error) {
        console.log(error);
      }
   
  //  getClearingNames(state.memberId, profile);
    return () => { ismounted = false };

  }, [refresh, props.refresh]
  );

  function ModalState() {
    setModal( 
        {
          ...modal,
          modal: !modal.modal
        }
      )
  }

  async function GenerateInvoice() {
      const result = await AdminService.createInvoice();
      alert(JSON.stringify(result))
      setRefresh( {refresh: true} )
  }
  

  function GenerateDetails()
  {

    setModal( 
      {
          modal: true
      }
    );
  }

 const handlePrintOriginal = useReactToPrint({
      content: () => InvoiceRef.current,
      documentTitle: 'Invoice',
      
    });

    
 async function PayInvoice(props)
 {
    await AdminService.payInvoice(props.invoice_id)
     try {


        // set loading to true before calling API
          /*data = */ AdminService.getInvoices().then(data => { setData(data)});

        /*setData(data);*/

      } catch (error) {
        console.log(error);
      }
 }

   async function onRowClickHandler(event) {

        setInvoiceDetails(
          {
             invoiceId: event.invoice_id,
             memberId: event.member_id,
             amountDue: event.amount_due
          }
        )
        ModalState();

      
        
    }


  const columns = [
    {
      name: 'Invoice Id',
      selector: data => data.invoice_id.toString(),
      sortable: true,
      width: '10%'
    },
    {
      name: 'Member',
      selector: data => data.member_id.toString(),
      sortable: true,
      width: '15%'
    },
    {
      name: 'Invoice Month',
      sortable: true,
      selector: data => data.invoice_month,
      width: '15%'
    },
    {
      name: ('Invoice Date'),
      selector: data => data.created_date,
      cell: data => data.created_date.toString().substring(5,7) + '/' + data.created_date.toString().substring(8,10) + '/' + data.created_date.toString().substring(0,4),
      sortable: true,
      width: '15%'
    },
    {
      name: ('Amound Due'),
      selector: data => data.amount_due,
      sortable: true,
      wrap: true,
      width: '15%'
    },
    {
      name: 'Date Paid',
      selector: data => !data.date_paid?"":data.date_paid.toString(),
      sortable: true,
      wrap: true,
      width: '15%'
    },
    {
      name: 'Mark Paid',
      selector: data => !data.date_paid?PayInvoiceButton({invoice_id: data.invoice_id}):"",
      sortable: true,
      wrap: true,
      width: '15%'
    }
    ]
    
  const InvoiceDataTable = (props) =>
  {
    // alert(JSON.stringify(specialNamesData))

    if (!data) return (
      <span>Data not available</span>
    );

    return (
        <Row className="px-1">
            <DataTable onRowClicked={onRowClickHandler}
                  highlightOnHover={true}
                  customStyles={tableCustomerStyles} columns={columns}
              data={data}
              ></DataTable>
        </Row>)
  }


  const PayInvoiceButton = (props) =>
    {
      
        return(
          <div>
          <button type="button" class="btn btn-link" onClick={() => PayInvoice(props)} >Mark Paid</button>
          </div>
        )
    } 


  return (
     <ProtectedRoute>
        <Container className="main-content-container px-3 pb-3">
        
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title="Meeting Name Report"
            className="text-sm-left"
          />
          </Row>
    <Card small className="mb-3">
     
        <CardHeader className="border-bottom">
          <h5>
            A La Carte Invoice
          </h5>
        </CardHeader>
        <CardBody>
        <Modal open={modal.modal} className="modal-lg" >
          <ModalHeader>Report Access Details</ModalHeader>
          <ModalBody>
          <div className="d-flex gap-2 flex-row-reverse bd-highlight">
          <Button size="sm" theme="info" className="mb-2 mr-1" onClick={() => ModalState()}>Close</Button>
          <Button size="sm" theme="info" className="mb-2 mr-1" onClick={() => handlePrintOriginal()}>Print</Button>
          </div>
          <div
              ref={InvoiceRef}
              className="print-component"
              
            >
          <InvoiceDetails invoiceId={invoiceDetails.invoiceId} memberId={invoiceDetails.memberId} amountDue={invoiceDetails.amountDue}></InvoiceDetails>
                      
          </div>
          </ModalBody>
        </Modal>
        
        <Col>
          
          <CardHeader className="border-bottom mb-2">
            
          <div className="text-center fs-6 fw-bold">Invoices</div>
          </CardHeader>
          <div className="d-flex gap-2 flex-row-reverse bd-highlight"><button type="button" size="sm" className="btn btn-primary" onClick={() => GenerateInvoice()}>Generate Invoices</button></div>
          <InvoiceDataTable
          
          data={props}></InvoiceDataTable>
        </Col>
         
        </CardBody>
    </Card>
    </Container>
        </ProtectedRoute>
  )
}

